import type { RibbonControlGroupDefinitionMLR, RibbonTabDefinitionBase } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";
import { constructKeytip, Multiline } from "owa-command-ribbon";
import loc from "owa-localize";
import { getMailRibbonConfigStore } from "owa-mail-ribbon-store/lib/store/store";
import { folder_tab as Strings_folder_tab } from "owa-mail-ribbon-utils/lib/ribbon_mail_strings.locstring.json";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { getUniqueTabId } from "owa-mail-ribbon-utils/lib/getUniqueTabId";
import { type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import { getMLRTabGroups } from "../../../util/getTabGroups";
import { getMLRFolderTabCommonGroupFlyout } from "./getMLRFolderTabCommonGroupFlyout";
import { getMLRFolderTabControlDefinition } from "./getMLRFolderTabControlDefinition";
import { getMLRFolderTabGroupLayouts } from "./getMLRFolderTabGroupLayouts";

const getMLRFolderTab: (props: ReadOnlyRibbonControlDefProps) => RibbonTabDefinitionBase = owaComputedFn(function getMLRFolderTab(props: ReadOnlyRibbonControlDefProps): RibbonTabDefinitionBase {
    return {
        type: Multiline,
        id: getUniqueTabId(17, undefined /* editorId */, props.itemId, props.isPopout),
        title: loc(Strings_folder_tab),
        controlGroups: { type: Multiline, groups: getFolderTabGroups(props) },
        initialScalingSteps: [],
        scalingSteps: [],
        keytipProps: constructKeytip([], 17, true /* hasMenu */),
    };
});

const getFolderTabGroups: (props: ReadOnlyRibbonControlDefProps) => RibbonControlGroupDefinitionMLR[] = owaComputedFn(function getFolderTabGroups(props: ReadOnlyRibbonControlDefProps): RibbonControlGroupDefinitionMLR[] {
    let folderTabGroups: RibbonControlGroupDefinitionMLR[] = new Array();
    folderTabGroups = getMLRTabGroups(17, getMailRibbonConfigStore(props.mailboxInfo).multiline.folderTab.layout, getMLRFolderTabControlDefinition, getMLRFolderTabGroupLayouts, getMLRFolderTabCommonGroupFlyout, props);
    
    return folderTabGroups;
});

export default getMLRFolderTab;
